enum MessageAllPrivateEventParticipantsTypeEnum {
  Accepted = 'Accepted',
  NotAccepted = 'Not Acccepted',
  All = 'All'
}

export default MessageAllPrivateEventParticipantsTypeEnum;
